import { OmniMaisV2RestService } from './../../omni-rest/omni-mais/omni-mais-v2-rest.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OmniMaisRestService } from './../../omni-rest/omni-mais/omni-mais-rest.service';
import {
  SimuladorVeiculoParamsSimulacao,
  SimuladorVeiculoResultSimulacao,
} from '../models/simulador-veiculo-ficha.model';

@Injectable()
export class SimuladorVeiculoFichaService {
  constructor(private restService: OmniMaisRestService, private restServiceV2: OmniMaisV2RestService) {}

  getSimulacao(
    params: SimuladorVeiculoParamsSimulacao
  ): Observable<SimuladorVeiculoResultSimulacao> {
    return this.restServiceV2.get('proposta/simulacao', { params });
  }

  getExibirMenuSimulacao(): Observable<{
    allowAccess: boolean;
    messages: string[];
    status: string;
  }> {
    return this.restService.get('agents/show-menu-simulation');
  }
}
